// Table of contents:
// 1 eInvoiceCockpit
import { EInvoiceCockpit } from '../../../data'
import { getTranslationsForConfig } from '../getTranslationsForConfig'

export const createEInvoiceCockpit = (): EInvoiceCockpit => {
  return {
    // 1 eInvoiceCockpit
    eInvoiceCockpit: {
      enabled: true,
      table: {
        enabled: true,
        columns: [
          {
            // Test und Herkunft
            field: 'Meta',
            header: getTranslationsForConfig(
              'eInvoiceOverview.table.columns.testAndSource.header',
            ), // i18n.t('eInvoiceOverview.table.columns.testAndSource.header')
          },
          {
            // CompanyCodeMasterData
            field: 'Payload.CompanyCodeMasterData.Common.Company',
            header: getTranslationsForConfig(
              'eInvoiceCockpit.table.columns.companyCodeMasterData.header',
            ), // i18n.t('eInvoiceCockpit.table.columns.companyCodeMasterData.header')
          },
          {
            // SupplierMasterData
            field: 'Payload.SupplierMasterData.Common.Company',
            header: getTranslationsForConfig(
              'eInvoiceCockpit.table.columns.supplierMasterData.header',
            ), // i18n.t('eInvoiceCockpit.table.columns.supplierMasterData.header')
            enabled: false,
          },
          {
            // LegalMonetaryTotal
            field: 'Payload.LegalMonetaryTotal.PayableAmount.Value.Value',
            header: getTranslationsForConfig(
              'eInvoiceCockpit.table.columns.legalMonetaryTotal.header',
            ), // i18n.t('eInvoiceCockpit.table.columns.legalMonetaryTotal.header')
          },
          {
            // ID
            field: 'Payload.ID.Value.Value',
            header: getTranslationsForConfig(
              'eInvoiceCockpit.table.columns.invoiceNumber.header',
            ), // i18n.t('eInvoiceCockpit.table.columns.invoiceNumber.header')
          },
          {
            // InvoiceDate
            field: 'Payload.IssueDate.Value',
            header: getTranslationsForConfig(
              'eInvoiceCockpit.table.columns.invoiceDate.header',
            ), // i18n.t('eInvoiceCockpit.table.columns.invoiceDate.header')
          },
          {
            // invoiceClassification
            field: 'Meta.controlInformation.invoiceClassification',
            header: getTranslationsForConfig(
              'eInvoiceCockpit.table.columns.invoiceClassification.header',
            ), // i18n.t('eInvoiceCockpit.table.columns.invoiceClassification.header')
          },
          {
            // OrderReference
            field: 'Payload.OrderReference.ID.Value.Value',
            header: getTranslationsForConfig(
              'eInvoiceCockpit.table.columns.orderReference.header',
            ), // i18n.t('eInvoiceCockpit.table.columns.orderReference.header')
          },
          {
            // CreatedBy
            field: 'Meta.file.uploadedBy',
            header: getTranslationsForConfig(
              'eInvoiceCockpit.table.columns.createdBy.header',
            ), // i18n.t('eInvoiceCockpit.table.columns.createdBy.header')
          },
          {
            // CreatedAt
            field: 'Meta.file.uploadedAt',
            header: getTranslationsForConfig(
              'eInvoiceCockpit.table.columns.createdAt.header',
            ), // i18n.t('eInvoiceCockpit.table.columns.createdAt.header')
          },
          {
            // Status
            field: 'Meta.file.status',
            header: getTranslationsForConfig(
              'eInvoiceCockpit.table.columns.status.header',
            ), // i18n.t('eInvoiceCockpit.table.columns.status.header')
          },
        ],
        emptyMessageDetails: getTranslationsForConfig(
          'eInvoiceOverview.table.emptyMessageDetails',
        ), // i18n.t('eInvoiceOverview.table.emptyMessageDetails')
        emptyMessageTitle: getTranslationsForConfig(
          'eInvoiceOverview.table.emptyMessageTitle',
        ), // i18n.t('eInvoiceOverview.table.emptyMessageTitle')
        paginator: true,
        rows: 20,
        rowsPerPageOptions: [20, 50, 100],
        sortField: 'Payload.InvoiceDate',
        sortOrder: -1,
      },
    },
  }
}
